import { render, staticRenderFns } from "./tdTotalWrap.vue?vue&type=template&id=9f8c490c&"
import script from "./tdTotalWrap.vue?vue&type=script&lang=js&"
export * from "./tdTotalWrap.vue?vue&type=script&lang=js&"
import style0 from "./tdTotalWrap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports